import { QueryCache, QueryClient } from '@tanstack/react-query';

const queryCache = new QueryCache();

const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const { response } = error ?? {};
        if (response?.status === 403) {
          return false;
        }
        if (failureCount < 3) {
          return true;
        }
        return false;
      },
      getPreviousPageParam: firstPage =>
        firstPage.pageable.pageNumber > 0 ? firstPage.pageable.pageNumber - 1 : undefined,
      getNextPageParam: lastPage => (!lastPage.last ? lastPage.pageable.pageNumber + 1 : undefined),
    },
  },
});

export default queryClient;
